import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <h1>Qutrix Assignment</h1>
    </header>
  );
};

export default Header;
